<template>
    <DashView>
        <div class="container-fluid pt-4 px-4">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <h3><a href="/group-register"><i class="fa fa-plus-square"></i></a>&nbsp;Groupes <span class="badge bgbadge">{{groupes.length}}</span> </h3>
                            <div class="table-responsive">
                                <template v-if="groupes.length>0">  
                                    <table class="table table-striped table-bordered display text-center">
                                        <thead>
                                            <tr>
                                                <th>Nom</th>
                                                <th>Description</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                                <tr v-for="groupe in groupes" :key="groupe.code_groupe">
                                                    <td>{{groupe.nom}}</td>
                                                    <td>{{groupe.description}}</td>
                                                    <td>{{groupe.status_groupe==1?'Actif':'Inactif'}}</td>
                                                    <td>
                                                        <router-link :to="{ name: 'group-update', params: { id: groupe.code_groupe } }" title="Gérer Groupe" @click="redirectTo(`/group-update/${groupe.code_groupe}`);"><i class="fa fa-users-cog"></i>&nbsp;Gérer</router-link>
                                                    </td>
                                                </tr>                                
                                        </tbody>
                                    </table>
                                </template>
                                <template v-else>
                                    <div class="modal-preloader">
                                        <div class="spinner"></div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
     <!--Begin All Modal -->
          <!--Begin voirdetails -->
          <div class="modal" id="voirdetails">
                  <div class="modal-dialog modal-dialog-centered">
                      <div class="modal-content">
  
                      <!-- Modal Header -->
                      <div class="modal-header">
                          <h4 class="modal-title text-center">Détails groupe</h4>
                          <button type="button" class="close" data-dismiss="modal">&times;</button>
                      </div>
  
                      <!-- Modal body -->
                      <div class="modal-body">
                         <template v-if="info_groupe?.code_groupe">
                          <div class="col-lg-12">
                              <div class="card mb-4">
                                  <div class="card-body">
                                      <div class="row">
                                          <div class="col-sm-4">
                                              <p class="mb-0">Code</p>
                                          </div>
                                          <div class="col-sm-8">
                                              <p class="text-muted mb-0">{{ info_groupe.code_groupe }}</p>
                                          </div>
                                      </div>
                                      <hr>
                                      <div class="row">
                                          <div class="col-sm-4">
                                              <p class="mb-0">Nom</p>
                                          </div>
                                          <div class="col-sm-8">
                                              <p class="text-muted mb-0">{{ info_groupe.nom }}</p>
                                          </div>
                                      </div>
                                      <hr>
                                      <div class="row">
                                          <div class="col-sm-4">
                                              <p class="mb-0">Description</p>
                                          </div>
                                          <div class="col-sm-8">
                                              <p class="text-muted mb-0">{{ info_groupe.description }}</p>
                                          </div>
                                      </div>
                                      <hr>
                                      <div class="row">
                                          <div class="col-sm-4">
                                              <p class="mb-0">Créer par </p>
                                          </div>
                                          <div class="col-sm-8">
                                              <p class="text-muted mb-0">{{ info_groupe.nom_user }} {{ info_groupe.prenom_user }}</p>
                                          </div>
                                      </div>
                                      <hr>
                                      <div class="row">
                                          <div class="col-sm-4">
                                              <p class="mb-0">Enrégistré le</p>
                                          </div>
                                          <div class="col-sm-8">
                                              <p class="text-muted mb-0">{{ formatDate(info_groupe.date_creation) }}</p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                         </template>
                         <template v-else>
                          <!-- <p class="text-center">Loading...</p> -->
                          <div class="modal-preloader">
                              <div class="spinner"></div>
                          </div>
                      </template>
                      </div>
  
                      <!-- Modal footer -->
                      <div class="modal-footer">
                          <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                      </div>
  
                      </div>
                  </div>
          </div>
          <!--End voirdetails -->
        <!-- End All Modal -->
</template>
<script>
import DashView from "@/components/DashView.vue"
import axios from 'axios'
  import $ from 'jquery';
  const base_url=process.env.VUE_APP_API_URL;
export default {
    name:"GroupAll",
    components:{
        DashView
    },
    data(){
      return{
          groupes:[],
          info_groupe:[],
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
      }
    },
    created(){
        // (JSON.parse(localStorage.getItem('user_zgc')).code_role)>3 ? this.$router.push('all-vente'):true;
        // const accessToken = JSON.parse(localStorage.getItem('user_zgc')).token ?? '';
        axios.get(`${base_url}/all_groupe`,{
                    headers:{
                            Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
              .then((response)=>{
                  console.log(response.data);
                  if(response.data){
                      this.groupes = response.data;
                  }
                  
                  
              })
              .catch((error)=>{
                console.log(error?.response?.status);
                if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
              });
    },
    methods:{
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = ('0' + date.getDate()).slice(-2);
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();
            const hours = ('0' + date.getHours()).slice(-2);
            const minutes = ('0' + date.getMinutes()).slice(-2);
            const seconds = ('0' + date.getSeconds()).slice(-2);

            return `${day}-${month}-${year} à ${hours}h ${minutes}mn ${seconds}s`;
        },
        getInfogroupe(code){ 
            //   console.log(code);
            const accessToken = JSON.parse(localStorage.getItem('user_zgc')).token ?? '';
            axios.get(`${base_url}/infoGroupe?code=${code}`,{
            headers:{
                Accept:'application/json',
                'Content-Type':'application/json;charset=UTF-8',
                Authorization:`Bearer ${accessToken}`
            }
        })
            .then((response)=>{
                const info = response.data;
            //   console.log(info);
                this.updateModalContent(info);
            })
            .catch((error)=>{
            if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
            }
            else {
            // Gérer d'autres erreurs ici
            console.log('Une erreur est survenue!');
            console.log('Autre erreur:', error);
            }
            })
        },
        updateModalContent(donnee){
            this.info_groupe=donnee;
        },
        redirectTo(path) {
            this.$router.push(path);
            setTimeout(function() {
            location.reload();
            }, 1);
        }

    }
}
</script>
<style lang="">
    
</style>